angular.module('filters').filter('membershipPlanCategoryFilter', function() {
  return function(category) {
    return category || 'N/A';
  };
});
